import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "card-header border-0 cursor-pointer bg-success",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#register_trainee",
  "aria-expanded": "true",
  "aria-controls": "form"
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title m-0" }, [
    /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder text-light m-0" }, "Field Visit List")
  ])
], -1)
const _hoisted_3 = {
  id: "register_trainee",
  class: "collapse show"
}
const _hoisted_4 = { class: "collapse show" }
const _hoisted_5 = { class: "card-body border-top p-6" }
const _hoisted_6 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col-md-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Type of Visitor", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_11 = { class: "col-md-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Visit Type", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "col-md-2 mt-2" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-search" }, null, -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("h4", { class: "mt-6" }, "Visit List", -1)
const _hoisted_17 = { class: "card mb-5 mb-xl-10" }
const _hoisted_18 = {
  class: "card-header border-0 cursor-pointer bg-light px-4",
  role: "button",
  "data-bs-target": "#trainee_data",
  "aria-expanded": "true",
  "aria-controls": "form"
}
const _hoisted_19 = { class: "row mt-1 w-100 m-0" }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "div pb-2" }
const _hoisted_22 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-6 mt-1 text-end\" data-v-54b12dc8=\"\"><button type=\"button\" class=\"btn btn-dark fs-7 p-2 rounded-0\" title=\"Download Xlse\" data-v-54b12dc8=\"\"><i class=\"fas fa-file-excel fs-5\" data-v-54b12dc8=\"\"></i> Excel </button><button type=\"button\" class=\"btn btn-warning fs-7 p-2 rounded-0\" title=\"Download PDF\" data-v-54b12dc8=\"\"><i class=\"fas fa-file-pdf fs-5\" data-v-54b12dc8=\"\"></i> PDF </button><button type=\"button\" class=\"btn btn-primary fs-7 p-2 rounded-0\" title=\"Download CSV\" data-v-54b12dc8=\"\"><i class=\"fas fa-file-csv fs-5\" data-v-54b12dc8=\"\"></i> CSV </button></div>", 1)
const _hoisted_23 = {
  id: "trainee_data",
  class: "collapse show"
}
const _hoisted_24 = { class: "collapse show" }
const _hoisted_25 = { class: "card-body border-top p-6" }
const _hoisted_26 = {
  class: "current",
  "data-kt-stepper-element": "content"
}
const _hoisted_27 = ["onClick"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("i", { class: "fas text-light fa-pencil-alt" }, null, -1)
const _hoisted_29 = [
  _hoisted_28
]
const _hoisted_30 = ["onClick"]
const _hoisted_31 = /*#__PURE__*/_createElementVNode("i", { class: "fas text-light fa-trash-alt" }, null, -1)
const _hoisted_32 = [
  _hoisted_31
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_KTDrawerFieldVisitUpdate = _resolveComponent("KTDrawerFieldVisitUpdate")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _hoisted_9,
                  _hoisted_10,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Type of Visitor",
                    modelValue: _ctx.batch.visitor_type,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.batch.visitor_type) = $event)),
                    filterable: "",
                    multiple: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visitorType, (type) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: type.id,
                          label: type.name,
                          value: type.id
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(type.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_11, [
                  _hoisted_12,
                  _hoisted_13,
                  _createVNode(_component_el_select, {
                    class: "form-select-solid",
                    placeholder: "Select Visit Type",
                    modelValue: _ctx.batch.visit_type,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.batch.visit_type) = $event)),
                    filterable: "",
                    multiple: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_option, {
                        label: "Surprise Visit",
                        value: "Surprise"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Surprise Visit")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_option, {
                        label: "Regular Visit",
                        value: "Regular"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Regular Visit")
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_option, {
                        label: "Inqueray Visit",
                        value: "Inqueray"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("Inqueray Visit")
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("button", {
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.getVisitList())),
                    type: "button",
                    class: "btn btn-success mt-6 p-3",
                    style: {"padding-top":"8px !important","padding-bottom":"8px !important"}
                  }, [
                    _createTextVNode(" Search "),
                    _hoisted_15
                  ])
                ])
              ]),
              (_ctx.showTable)
                ? (_openBlock(), _createElementBlock("div", { key: _ctx.componentKey }, [
                    _hoisted_16,
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("div", _hoisted_18, [
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                              _withDirectives(_createElementVNode("input", {
                                type: "text",
                                class: "form-control ps-10 w-200px mt-1 form-control-sm",
                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.search) = $event)),
                                onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.searchItems())),
                                style: {"height":"1em"},
                                placeholder: "Search"
                              }, null, 544), [
                                [_vModelText, _ctx.search]
                              ])
                            ])
                          ]),
                          _hoisted_22
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_23, [
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("div", _hoisted_26, [
                              _createVNode(_component_Datatable, {
                                "table-data": _ctx.visitList,
                                "table-header": _ctx.tableHeader,
                                "enable-items-per-page-dropdown": true
                              }, {
                                "cell-photo": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry.photo), 1)
                                ]),
                                "cell-ins_name": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry?.institute_info?.institute_name), 1)
                                ]),
                                "cell-institute_address": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry?.institute_info?.address), 1)
                                ]),
                                "cell-association": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry?.visited_entity_info?.entity_short_name), 1)
                                ]),
                                "cell-date_of_visit": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry.visited_date? _ctx.moment(industry?.visited_date).format(
                                'DD-MM-YYYY'
                              ): ''), 1)
                                ]),
                                "cell-officer_name": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry?.employee?.name), 1)
                                ]),
                                "cell-institute_district": _withCtx(({ row: industry }) => [
                                  _createTextVNode(_toDisplayString(industry?.district_info?.district_name_eng), 1)
                                ]),
                                "cell-officer_organization": _withCtx(({
                            row: industry,
                          }) => [
                                  _createTextVNode(_toDisplayString(industry?.concerned_entity_info
                                ?.entity_short_name), 1)
                                ]),
                                "cell-officer_designation": _withCtx(({
                                row: industry,
                              }) => [
                                  _createTextVNode(_toDisplayString(industry?.employee?.designation), 1)
                                ]),
                                "cell-actions": _withCtx(({ row: industry }) => [
                                  _createElementVNode("button", {
                                    onClick: ($event: any) => (_ctx.edit(industry.id)),
                                    "data-kt-drawer-toggle": "true",
                                    "data-kt-drawer-target": "#kt_drawer_fieldVisit_update",
                                    id: "kt_drawer_fieldVisit_update_button",
                                    class: "btn btn-icon btn-bg-primary btn-active-color-primary btn-sm me-1"
                                  }, _hoisted_29, 8, _hoisted_27),
                                  _createElementVNode("button", {
                                    onClick: ($event: any) => (_ctx.Delete(industry.id)),
                                    class: "btn btn-icon btn-bg-danger btn-active-color-primary btn-sm"
                                  }, _hoisted_32, 8, _hoisted_30)
                                ]),
                                _: 1
                              }, 8, ["table-data", "table-header"])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ])), [
        [_directive_loading, _ctx.load]
      ])
    ]),
    _createVNode(_component_KTDrawerFieldVisitUpdate)
  ], 64))
}